export default {
  props: {
    styling: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    },
    themeSettings: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    },
    card: {
      type: Boolean,
      default: false,
      required: false
    },
    hoverCardEnabled: {
      type: Boolean,
      default: false
    },
    packPricingEnabled: {
      type: Boolean,
      default: false,
      required: false
    },
    item: {
      type: Object,
      required: true
    },
    rrpAllowed: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data: function() {
    return {
      quantity: 1,
      isVisible: false
    }
  },
  computed: {
    image() {
      if (this.item.images && this.item.images.length > 0 && this.item.images[0].image) {
        return this.item.images[0].image
      }
      return null
    },
    title() {
      return this.item.title || ''
    },
    abstract() {
      return this.item.abstract || ''
    },
    path() {
      if (!this.item.path) return ''
      if (this.item.path.charAt(0) !== '/') return `/${this.item.path}`
      return this.item.path
    },
    price() {
      return this.$store.getters['products/basePrice'](this.item.id)
    },
    productStock() {
      return this.$store.getters['products/currentStock'](this.item.id)
    },
    lowStockThreshold() {
      return this.$store.getters['productCatalog/getLowStockThreshold']
    },
    lowStock() {
      return this.productStock <= this.lowStockThreshold
    },
    outOfStock() {
      return this.productStock <= 0
    },
    onRequest() {
      if (this.$store.getters['user/userid'] === '1') return false
      return this.item.catalogproductaccess && this.item.catalogproductaccess.length !== 0 && !this.$store.getters['user/hasAnyRole'](this.item.catalogproductaccess.map(data => data.role))
    },
    showPrice() {
      if (!this.onRequest || !this.item.noaccess_option) return true
      if (this.item.noaccess_option === 'show' || this.item.noaccess_option === 'hide_club') return true
      return false
    },
    stockManagedClass() {
      if (this.outOfStock) return 'sold-out'
      if (this.onRequest) return 'on-request'
      return 'add-to-cart'
    },
    stockManagedText() {
      if (this.outOfStock) return 'Sold Out'
      if (this.onRequest) return 'On Request'
      return 'Add To Cart'
    },
    stockManaged() {
      return this.$store.getters['products/managedStock'](this.item.id)
    },
    displayRRP() {
      return (this.rrpAllowed && (this.rrpPrice - this.sellPrice) > 0)
    },
    // This property has been created to account for discounts
    // applied to the sellPrice of a product. When this occurs
    // the basePrice reflects the difference between the two.
    displayBasePrice() {
      return (this.hasSavings > 0 && this.basePrice > this.sellPrice)
    },
    packPriceLabel: function() { return this.$store.getters['products/packPriceLabel'](this.itemid) },
    packPrice: function() { return this.$store.getters['products/packPrice'](this.itemid) },
    rrpPrice: function() { return this.$store.getters['products/rrpPrice'](this.itemid) },
    sellPrice: function() { return this.$store.getters['products/sellPrice'](this.itemid) },
    basePrice: function() { return this.$store.getters['products/basePrice'](this.itemid) },
    hasSavings: function() { return this.$store.getters['products/hasSavings'](this.itemid) },
    varietal: function() { return this.item.varietal instanceof Array ? this.item.varietal.join(', ') : this.item.varietal },
    hasVarietal: function() { return this.varietal && this.varietal.toLowerCase() !== 'unknown' }
  },
  methods: {
    observeVisiblity() {
      return {
        callback: (isVisible, entry) => this.visibilityChanged(isVisible, entry),
        throttle: 300,
        throttleOptions: {
          leading: 'visible'
        }
      }
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        this.isVisible = isVisible
      }
    },
    // cartAddSuccess: function(cartItem) {
    //   this.$eventHub.$emit('productCartAdd', cartItem)
    // },
    cartAddFailed: function(err) {
      this.$store.dispatch('reportError', {
        type: 'error',
        ...err,
        timeout: 12500,
        notification: true,
        showClose: true
      })
    },
    addToCartLinkClicked(quantity) {
      if (this.onRequest) {
        return this.$eventHub.$emit('productRequestAdd', {
          mode: 'success',
          node: this.item,
          message: ''
        })
      }

      if (typeof quantity === 'undefined') {
        quantity = this.quantity
      }
      return this.$store.dispatch('ecommerce/cart_add_item', {
        qty: (typeof quantity === 'number' && quantity > 0) ? quantity : 1,
        item: {
          ...this.item,
          qty: (typeof quantity === 'number' && quantity > 0) ? quantity : 1
        }
      })
        .then(cartItem => {
          this.$eventHub.$emit('productCartAdd', {
            mode: 'success',
            node: this.item,
            message: ''
          })
        })
        .catch(e => {
          let message = e.message
          switch (e.name) {
            case 'InvalidCartQuantityError':
              message = '<p>Please enter a valid quantity of items to purchase or contact the Site Admin for further assistance.</p>'
              break
            case 'CartNotAvailableProductError':
              message = '<p>The product is not allowed to be added to the cart. Please contact the Site Admin for further assistance.</p>'
              break
            case 'MaxCartQuantityExceededError':
              message = `<p>You can only purchase a maximum of ${this.maxCartQtymaxCartAllowedQty} of <strong>${this.item.title}</strong> per transaction
              ${this.curentCartQty ? ' and you already have ' + this.curentCartQty + ' in your cart.' : '.'}</p>
              <p>Please lower the purchase quantity or contact the Site Admin for further assistance.</p>`
              break
          }
          this.$eventHub.$emit('productCartAdd', {
            mode: 'failure',
            node: this.item,
            message
          })
        })
    },
    updateQuantity(add) {
      if (add && this.quantity + 1 <= this.maxQty) {
        this.quantity += 1
      }
      else if (!add && this.quantity > 1) {
        this.quantity -= 1
      }
    },
    updateProductCartData(value) {
      Object.keys(value).map(k => {
        this.$set(this.cartData, k, value[k])
      })
    }
  }
}
